module.exports = __webpack_public_path__ + "img/event4.4522f9bf.png";